var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEnvironmentCalendarActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 2.50016H17.4993C17.9596 2.50016 18.3327 2.87326 18.3327 3.3335V16.6668C18.3327 17.1271 17.9596 17.5002 17.4993 17.5002H2.49935C2.03912 17.5002 1.66602 17.1271 1.66602 16.6668V3.3335C1.66602 2.87326 2.03912 2.50016 2.49935 2.50016H5.83268V0.833496H7.49935V2.50016H12.4993V0.833496H14.166V2.50016ZM3.33268 7.50016V15.8335H16.666V7.50016H3.33268ZM4.99935 10.8335H9.16602V14.1668H4.99935V10.8335Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnvironmentCalendarActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EnvironmentCalendarActive.90ab559e.svg";
export { ForwardRef as ReactComponent };